export default "__VITE_ASSET__CLroPzgt__"